/* eslint react/prefer-stateless-function: 0 */
import React, { Component } from 'react'
import { formatterTypes } from './types'

export default (WrappedComponent) => class InjectUnits extends Component {

  static contextTypes = formatterTypes

  render () {
    return (
      <WrappedComponent
        {...this.props}
        formatDistance={this.context.formatDistance}
        formatDuration={this.context.formatDuration}
        formatElevation={this.context.formatElevation}
        formatEnergy={this.context.formatEnergy}
        formatHeartRate={this.context.formatHeartRate}
        formatPace={this.context.formatPace}
        formatSpeed={this.context.formatSpeed}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/units/injectUnits.js